<script setup>
import { useRoute } from '@js/utils/route';

const { quotation, callback } = defineProps({
    quotation: {
        type: Object,
        required: true,
    },
    callback: {
        type: Function,
        required: false,
    },
});

const { route } = useRoute();

function toggleAction() {
    let url = route(
        'front.projectManagement.apikom.postToggleQuotationToCall',
        {
            quotation: quotation.id,
        },
    );

    axios
        .post(url)
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .catch((error) => {
            console.error(error);
        });
}
</script>

<template>
    <slot name="button" :action="toggleAction" />
</template>
